import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceAdminSetRemoteSourcePayload } from 'api/actions/device-admin-set-remote-source/device-admin-set-remote-source-payload';
import { DeviceAdminSetRemoteSourcePathParameters } from 'api/actions/device-admin-set-remote-source/device-admin-set-remote-source-path-parameters';
import { DeviceAdminSetRemoteSourceResponse } from 'api/actions/device-admin-set-remote-source/device-admin-set-remote-source-response';

type DeviceAdminSetRemoteSourceQueryParameters = Record<string, any>;

/**
 * The path of the DeviceAdminSetRemoteSource action.
 */
export const deviceAdminSetRemoteSourceActionPath = new SweetPath<keyof DeviceAdminSetRemoteSourcePathParameters>(
  '/api/device/admin-set-remote-source/{deviceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceAdminSetRemoteSource actions.
 */
export default function createDeviceAdminSetRemoteSourceAction(axios: AxiosInstance) {
  return function deviceAdminSetRemoteSourceAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceAdminSetRemoteSourcePathParameters;
    query?: DeviceAdminSetRemoteSourceQueryParameters;
    payload: DeviceAdminSetRemoteSourcePayload;
  }) {
    const path = deviceAdminSetRemoteSourceActionPath.insert(parameters);

    return axios.request<DeviceAdminSetRemoteSourceResponse, DeviceAdminSetRemoteSourceResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
